import {Component} from '@angular/core';
import {NavigationEnd, Router, RouterModule, RouterOutlet} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {PrimeNGConfig} from 'primeng/api';
import translationsES from '../../public/i18n/es.json';
import translationsEN from '../../public/i18n/en.json';
import translationsPT from '../../public/i18n/pt.json';
import {Subject, takeUntil} from 'rxjs';
import {BlockUIModule} from "primeng/blockui";
import {SpinnerComponent} from "./public/spinner/spinner.component";
import {LoaderService} from "./service/loader.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterModule,
    BlockUIModule,
    SpinnerComponent,
  ],
  template: `
    <router-outlet/>
    <p-blockUI [blocked]="loaderService.statusLoader" [autoZIndex]="false" [baseZIndex]="500000">
      <app-spinner></app-spinner>
    </p-blockUI>`,
})
export class AppComponent {
  title = 'Falcon';
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    public loaderService: LoaderService,
    public primengConfig: PrimeNGConfig,
    private router: Router,
    private readonly translateService: TranslateService
  ) {
    this.translateService.setTranslation('es', translationsES);
    this.translateService.setTranslation('en', translationsEN);
    this.translateService.setTranslation('pt', translationsPT);
    this.translateService.setDefaultLang('pt');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        //sessionStorage.clear();
        if(event.urlAfterRedirects !== '/fromnexus' && event.urlAfterRedirects !== '/login'){
          sessionStorage.setItem('lastRoute', event.urlAfterRedirects);
        }
      }
    });
  }

  ngOnInit() {
    console.log('FALCON NEXUS')
    this.setCalendarTranslation();
    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.setCalendarTranslation();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setCalendarTranslation(): void {
    this.primengConfig.setTranslation({
      dayNames: [
        this.translateService.instant('calendar.dayNames.sunday'),
        this.translateService.instant('calendar.dayNames.monday'),
        this.translateService.instant('calendar.dayNames.tuesday'),
        this.translateService.instant('calendar.dayNames.wednesday'),
        this.translateService.instant('calendar.dayNames.thursday'),
        this.translateService.instant('calendar.dayNames.friday'),
        this.translateService.instant('calendar.dayNames.saturday'),
      ],
      dayNamesShort: [
        this.translateService.instant('calendar.dayNamesShort.sun'),
        this.translateService.instant('calendar.dayNamesShort.mon'),
        this.translateService.instant('calendar.dayNamesShort.tue'),
        this.translateService.instant('calendar.dayNamesShort.wed'),
        this.translateService.instant('calendar.dayNamesShort.thu'),
        this.translateService.instant('calendar.dayNamesShort.fri'),
        this.translateService.instant('calendar.dayNamesShort.sat')
      ],
      dayNamesMin: [
        this.translateService.instant('calendar.dayNamesMin.su'),
        this.translateService.instant('calendar.dayNamesMin.mo'),
        this.translateService.instant('calendar.dayNamesMin.tu'),
        this.translateService.instant('calendar.dayNamesMin.we'),
        this.translateService.instant('calendar.dayNamesMin.th'),
        this.translateService.instant('calendar.dayNamesMin.fr'),
        this.translateService.instant('calendar.dayNamesMin.sa')
      ],
      monthNames: [
        this.translateService.instant('calendar.monthNames.january'),
        this.translateService.instant('calendar.monthNames.february'),
        this.translateService.instant('calendar.monthNames.march'),
        this.translateService.instant('calendar.monthNames.april'),
        this.translateService.instant('calendar.monthNames.may'),
        this.translateService.instant('calendar.monthNames.june'),
        this.translateService.instant('calendar.monthNames.july'),
        this.translateService.instant('calendar.monthNames.august'),
        this.translateService.instant('calendar.monthNames.september'),
        this.translateService.instant('calendar.monthNames.october'),
        this.translateService.instant('calendar.monthNames.november'),
        this.translateService.instant('calendar.monthNames.december'),
      ],
      monthNamesShort: [
        this.translateService.instant('calendar.monthNamesShort.jan'),
        this.translateService.instant('calendar.monthNamesShort.feb'),
        this.translateService.instant('calendar.monthNamesShort.mar'),
        this.translateService.instant('calendar.monthNamesShort.apr'),
        this.translateService.instant('calendar.monthNamesShort.may'),
        this.translateService.instant('calendar.monthNamesShort.jun'),
        this.translateService.instant('calendar.monthNamesShort.jul'),
        this.translateService.instant('calendar.monthNamesShort.aug'),
        this.translateService.instant('calendar.monthNamesShort.sep'),
        this.translateService.instant('calendar.monthNamesShort.oct'),
        this.translateService.instant('calendar.monthNamesShort.nov'),
        this.translateService.instant('calendar.monthNamesShort.dec'),
      ],
      dateFormat: this.translateService.instant('calendar.dateFormat'),
      emptyMessage: this.translateService.instant('calendar.emptyMessage'),
    });
  }
}
